import { R2GATE_MODULE_TYPE } from '@/api/type/commonTypes';
import {
  GetLicenseKeyListResponse,
  LicenseKeyListItemType,
} from '@/api/type/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LicenseState {
  licenseList: GetLicenseKeyListResponse | null;
}

const initialState: LicenseState = {
  licenseList: null,
};

export const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    setLicenseList: (
      state,
      action: PayloadAction<GetLicenseKeyListResponse>
    ) => {
      state.licenseList = action.payload;
    },
    revokeLicenseItem: (state, action: PayloadAction<string>) => {
      if (!state.licenseList) return;

      const target = state.licenseList.items.find(
        (item) => item.licenseKeyId === action.payload
      );

      if (!target) return;

      target.status = 'REVOKED';
      target.revokedAt = new Date().toISOString();
    },
    addLicenseItems: (
      state,
      action: PayloadAction<{
        module: R2GATE_MODULE_TYPE;
        keys: string[];
        issuerName: string;
        reason: string;
      }>
    ) => {
      if (!state.licenseList) return;

      const now = new Date().toISOString();

      const newItems: LicenseKeyListItemType[] = action.payload.keys.map(
        (key) => ({
          no: 0,
          licenseKeyId: key,
          module: action.payload.module,
          status: 'UNREGISTERED',
          createdAt: now,
          registeredAt: undefined,
          revokedAt: undefined,
          issuerName: action.payload.issuerName,
          issuanceReason: action.payload.reason,
        })
      );

      state.licenseList.items = [...newItems, ...state.licenseList.items].map(
        (item, index) => ({
          ...item,
          no: index + 1,
        })
      );

      state.licenseList.totalElements = state.licenseList.items.length;
    },
    addLicenseItemMemo: (
      state,
      action: PayloadAction<{
        licenseKeyId: string;
        memo: string;
        memoIssuerName: string;
        memoCreatedAt: string;
      }>
    ) => {
      if (!state.licenseList) return;

      const target = state.licenseList.items.find(
        (item) => item.licenseKeyId === action.payload.licenseKeyId
      );

      if (!target) return;

      target.memo = action.payload.memo;
      target.memoIssuerName = action.payload.memoIssuerName;
      target.memoCreatedAt = action.payload.memoCreatedAt;
    },
  },
});

export const license = licenseSlice.actions;
export default licenseSlice.reducer;
